export default function Quote({ children, quote, author }){
  return (
    <section className="callout !pb-6">
      <div className="!font-['Inter'] text-2xl leading-relaxed text-maingray">
        {children}
      </div>
      <div className="text-secgray text-xl">
        {author}
      </div>
    </section>
  )
}